import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ReviewAndAcceptWorkOrderTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REVIEW_AND_ACCEPT_WORK_ORDER),
  payload: z.discriminatedUnion("attemptType", [
    z.object({
      attemptType: z.literal("ACCEPT"),
      workOrderId: z.number(),
      estimatedStartWeekDate: z.coerce.date().nullable(),
      estimatedEndWeekDate: z.coerce.date().nullable().optional(),
      permitProjectId: z.number().nullable(),
      inspectionProjectId: z.number().nullable(),
    }),
    z.object({
      attemptType: z.literal("REJECT"),
      workOrderId: z.number(),
      rejectionReason: z.string(),
    }),
  ]),
});

export type ReviewAndAcceptWorkOrderTaskAttempt = z.infer<typeof ReviewAndAcceptWorkOrderTaskAttemptSchema>;
